import { businessDateValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { carouselConfigValidator } from '../../../subcomponents/carousel/types/config';
import { defaultDatePickerCarouselConfig } from '../../../subcomponents/date-picker/types/props';
import { defaultShowtimePickerConfig, defaultShowtimePickerConfigValidatorSchema } from '../../../subcomponents/showtime-picker/types/config';
import { DateShowtimePickerSelectedBusinessDate } from './selected-business-date';
const defaultDateShowtimePickerConfigBase = Object.assign(Object.assign({}, defaultShowtimePickerConfig), { actionButton: {
        show: true,
        showOnMessage: true
    }, datePicker: {
        show: true,
        selectedBusinessDate: DateShowtimePickerSelectedBusinessDate.Today,
        carousel: defaultDatePickerCarouselConfig
    } });
export const defaultDateShowtimePickerConfigWithFilmIds = defaultDateShowtimePickerConfigBase;
export const defaultDateShowtimePickerConfigWithoutFilmIds = Object.assign(Object.assign({}, defaultDateShowtimePickerConfigBase), { allFilmsToggle: {
        show: true,
        initialValue: false
    } });
export const showtimePickerDatePickerConfigValidator = Validator.object({
    show: Validator.boolean(),
    selectedBusinessDate: Validator.any([
        Validator.oneOf(Object.keys(DateShowtimePickerSelectedBusinessDate)),
        businessDateValidator
    ]),
    carousel: carouselConfigValidator
});
export const showtimePickerAllFilmsToggleValidator = Validator.object({
    show: Validator.boolean(),
    initialValue: Validator.boolean()
});
const defaultDateShowtimePickerConfigBaseValidatorSchema = Object.assign(Object.assign({}, defaultShowtimePickerConfigValidatorSchema), { datePicker: showtimePickerDatePickerConfigValidator });
export const dateShowtimePickerConfigWithFilmIdsValidator = Validator.object(defaultDateShowtimePickerConfigBaseValidatorSchema);
export const dateShowtimePickerConfigWithoutFilmIdsValidator = Validator.object(Object.assign(Object.assign({}, defaultDateShowtimePickerConfigBaseValidatorSchema), { allFilmsToggle: showtimePickerAllFilmsToggleValidator }));
